import React from 'react';
import { Grid } from '@material-ui/core'
import { Card1, Card2 } from 'components/Card';
import { useDevice } from 'components/DeviceContext.js';

const CriacaodoFia = () => {
    const {isMobile} = useDevice();
    return (
        <Grid item xs={12} md={12}
            style={{
                display: 'flex',
                justifyContent: 'space-around',
                fontFamily: 'Open sans',
                flexDirection: isMobile ? 'column' : '',
                padding: '1em'
            }}>
            <Grid item xs={12} md={5}>

                <h2 style={{
                    fontSize: '3em',
                    color: 'var(--azul-vivido)',
                    fontWeight: 400
                }}>FIA Municipal</h2>
                <h3
                    style={{
                        color: 'var(--laranja)',
                        fontWeight: 400,
                        fontSize: '1.4em'
                    }}>Criação do FIA Municipal</h3>
                <p style={{
                    borderLeft: '2px solid var(--cinza)',
                    padding: '0 1em',
                    textAlign: 'justify'
                }}>


                    <p>
                        <span
                            style={{
                                padding: '1em',
                                border: '2px solid var(--azul-vivido)',
                                color: 'var(--azul-vivido)',
                                borderRadius: '0.4em',
                            }}>1º
                        </span><span style={{
                            backgroundColor: 'var(--azul-vivido)',
                            padding: '0.6em',
                            color: 'var(--branco)',
                            borderRadius: '0 0.4em 0.4em 0'
                        }}>Passo – Instituição do FIA</span>
                    </p>
                    <p style={{padding: ' 0.8em 0'}}>
                    A instituição do FIA deve passar por aprovação de lei específica, sancionada pelo chefe do Poder Executivo Municipal, a normativa deve determinar a criação do Conselho. Após a sanção é necessário a regulamentação da lei, através de decreto.
                    </p>

                    <p>
                        <span
                            style={{
                                padding: '1em',
                                border: '2px solid var(--laranja)',
                                color: 'var(--laranja)',
                                borderRadius: '0.4em',
                                backgroundColor: 'none !important'
                            }}>2º
                        </span><span style={{
                            backgroundColor: 'var(--laranja)',
                            padding: '0.6em',
                            color: 'var(--branco)',
                            borderRadius: '0 0.4em 0.4em 0'
                        }}>Passo – Criando o CNPJ</span>
                    </p>
                    <p style={{padding: ' 0.8em 0'}}>
                    Depois de criado e regulamentado o Fundo da Infância e Adolescência, o representante legal do poder público municipal deve providenciar sua inscrição no CNPJ. O Fundo não tem personalidade jurídica própria, e, por isso, está vinculado administrativamente ao poder público. Dessa maneira, o fundo não realiza diretamente empréstimos, convênios, licitações, entre outros compromissos; tudo é feito em nome do Município, pois só este tem existência jurídica autônoma, representada pela autoridade municipal.
                    </p>
                    <p>
                        <span style={{fontWeight: 700}}>Quem deve fazer? </span> O gestor que tenha os dados necessários para o preenchimento das informações solicitadas pela Receita! Solicite ajuda de um contador!
                    </p>

                    <p>
                        <span style={{fontWeight: 700}}>Preenchimento e envio de documentos de solicitação de atos perante o CNPJ: </span>
                        <p>
                        A solicitação deve ser realizada através do Portal da Rede Nacional para a Simplificação do Registro e da Legalização de Empresas e Negócios, REDESIM (http://li.cnm.org.br/r/w35yCV), com a utilização do aplicativo Coletor Nacional.
                        </p>
                        <p>
                        Após o preenchimento e a transmissão das informações solicitadas o aplicativo gravará o Recibo de Entrega clicar no menu ("Finalizar Preenchimento”), que deve ser impresso, em 1 via, na opção "Preparar Página para Impressão”.
                        </p>
                        <p>
                        É possível acompanhar o andamento da solicitação através da opção "Consulta da Situação do Pedido de CNPJ enviado pela Internet”, no site da Secretaria da Receita Federal.
                        </p>
                        <p>
                        Havendo pendências, serão indicadas para consulta e resolução pelo contribuinte. Não havendo pendências, o sistema disponibilizará para impressão o Documento Básico de Entrada no CNPJ (DBE).
                        </p>
                        <p>
                        O DBE deverá ser encaminhando juntamente com os documentos necessários, via postal, pela entrega direta ou por outro meio aprovado pela RFB, à unidade cadastradora de jurisdição do estabelecimento.
                        </p>
                    </p>
                    <p style={{ backgroundColor: 'var(--azul-pastel)', padding: '0.8em', color: 'var(--azul-petroleo)' }}>
                        <strong>IMPORTANTE!</strong><br />
                        Não envie documentos originais e sim cópias autenticadas. Os documentos não serão devolvidos.<br />
                        Se o órgão de registro (junta comercial, cartório etc.) celebrou convênio de integração com a RFB, basta a entrega direta do DBE ou do Protocolo de Transmissão no órgão de registro.
                    </p>

                    <p style={{display: 'flex'}}>
                        <span
                            style={{
                                padding: '1em',
                                border: '2px solid var(--azul-vivido)',
                                color: 'var(--azul-vivido)',
                                borderRadius: '0.4em',
                                backgroundColor: 'none !important'
                            }}>3º
                        </span><span style={{
                            backgroundColor: 'var(--azul-vivido)',
                            padding: '0.6em',
                            color: 'var(--branco)',
                            borderRadius: '0 0.4em 0.4em 0',
                            display: 'flex',
                        }}>Passo – Cadastrar o FIA na Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDHC)</span>
                    </p>
                    <p>
                        O Cadastro dos Fundos consiste na sistematização de informações sobre Fundos da Criança e do Adolescente em todo o Brasil aptos a receberem doações dedutíveis do Imposto de Renda. As informações cadastrais dos Fundos são colhidas pelo Ministério dos Direitos Humanos e Cidadania, por meio da Secretaria Nacional dos Direitos da Criança e do Adolescente por intermédio de formulário disponível no site <a href="https://questionarios.mdh.gov.br/responder/e15xSrGvn3J2BjcEIzxC">https://questionarios.mdh.gov.br/responder/e15xSrGvn3J2BjcEIzxC</a>.
                    </p>
                    <p style={{ backgroundColor: 'var(--azul-pastel)', padding: '0.8em', color: 'var(--azul-petroleo)' }}>
                        <strong>IMPORTANTE!</strong><br />
                        O cadastro é imprescindível para tornar o respectivo Fundo apto a receber os recursos advindos das doações efetuadas por ocasião da Declaração de Ajuste Anual do Imposto de Renda.
                    </p>
                    <p>
                       <span style={{
                        fontWeight: '600'
                       }}> É responsabilidade da MDHC encaminhar à Receita Federal </span>, que, após verificada a devida regularidade, tornará o Fundo apto ao recebimento de doações por meio do Programa Gerador do Imposto de Renda.
                    </p>
                    <p>
                        Anualmente, <a href='https://www.gov.br/mdh/pt-br'>Ministério dos Direitos Humanos e Cidadania/MDHC</a> o  disponibiliza no  <a href="https://www.gov.br/mdh/pt-br ">https://www.gov.br/mdh/pt-br </a> a relação integral dos Fundos que constam em seu banco de dados, informando a situação cadastral dos fundos.
                    </p>
                </p>
            </Grid>
            <Grid item xs={12} md={4} style={{
                    padding: isMobile  ? '1em':''
                }}>
                    <Card1 />
                    <Card2 />

                </Grid>
        </Grid>
    );
};

export default CriacaodoFia;
